import React, {Component} from 'react';
import BaseMap from "./BaseMap";
import MapMarker from "./MapMarker";


export default class ProjectMap extends Component {

    constructor(props) {
        super(props);
        const items = this.props.items.map((item) => {
            item.lat=parseFloat(item.lat);
        item.lng=parseFloat(item.lng);
        return item
    });
        this.state = {
            groups: this.props.groups.map((group) => group.name),
        items: items
    };
        this.setGroups.bind(this);
    }
    setGroups(groups) {
        this.setState({groups});
    }
    render() {
        //Filter if comp has groups
        const items = this.props.groups.length?
            this.state.items.filter((item) => this.state.groups.includes(item.group)):
        this.state.items;

        return <div>
        <BaseMap height={parseInt(this.props.height)} zoom={this.props.zoom} items={items} basemap={this.props.basemap}>
            {items.map((item, index) => <MapMarker position={[item.lat, item.lng]} key={index} num={item.num} name={item.name} projectId={item.id}>
            {item.content}
            </MapMarker>)}
        </BaseMap>
            </div>;
    }
    }

    ProjectMap.defaultProps = {
        groups: [],
        height: 800
    };
